export default import.meta.ROLLDOWN_FILE_URL_p_NJd36jlm8nACpXawvJgw